import { render, staticRenderFns } from "./AdminAnnouncement.vue?vue&type=template&id=4c865044&scoped=true&"
import script from "./AdminAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AdminAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./AdminAnnouncement.vue?vue&type=style&index=0&id=4c865044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c865044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDialog,VIcon,VTextField})
